import type {Link} from 'link-preview/LinkDAO';

export const LINK_EVENT_PAYLOADS = {
  LINK_SYNC: {} as {
    added: Array<string>;
    removed: Array<string>;
  },
  LINK_PREVIEWS_FETCHED: {} as {
    previews: Array<Link>;
  },
} as const;

export type LinkEventPayload = typeof LINK_EVENT_PAYLOADS;
